import NotFound from "../exceptions/not-found";

class MemoryCache {
    constructor() {
        this.store = {};
        MemoryCache.instances.add(this);
    }

    static clearAll() {
        for (const cache of MemoryCache.instances) {
            cache.clear();
        }
    }

    setImmediate(object) {
        if (object.id) this.store[object.id] = object;
    }

    set(object) {
        this.setImmediate(object);
        return object;
    }

    setAll(objects) {
        objects.forEach((object) => {
            this.setImmediate(object);
        });
        return objects;
    }

    get(id) {
        const val = this.store[id];
        if (val) {
            return val;
        }
        throw new NotFound(id);
    }

    evict(id) {
        this.store[id] = null;
    }

    evictAll(ids = []) {
        ids.forEach((id) => {
            this.store[id] = null;
        });
    }

    clear(filter) {
        if (filter == null) {
            this.store = {};
        }
        if (typeof filter == "function") {
            const filtered = this.store.values().filter(filter);
            filtered.forEach((element) => {
                this.evict(element.id);
            });
        }
    }
}

MemoryCache.instances = new Set();

export default MemoryCache;
